export const EVENT_OPEN_WITHDRAW = "OPEN_WITHDRAW";
export const EVENT_CLOSE_WITHDRAW = "CLOSE_WITHDRAW";
